import { gql } from '@apollo/client';

export const PAST_LEAGUE_MEMBER_LINEUP = gql`
  query PastLeagueMemberLineup($matchWeekId: ID!, $fantasyLeagueMemberId: ID!) {
    pastLeagueMemberLineup(
      matchWeekId: $matchWeekId
      fantasyLeagueMemberId: $fantasyLeagueMemberId
    ) {
      id
      tactics
      budget
      totalScore
      createdAt
      updatedAt
      fantasyLeagueMember {
        id
        teamName
        user {
          fullName
          picture
          updatedAt
        }
      }
      matchWeek {
        id
        weekNumber
      }
      lineupPlayers {
        id
        startingPosition
        fantasyScore: calculatedFantasyScore
        createdAt
        player {
          id
          createdAt
          nick
          name
          lastName
          role
          marketValue
          image
          totalScore
          lastWeekNumber
          lastWeekScore
          team {
            id
            competition {
              id
              code
              displayName
              rank
            }
            createdAt
            nameShow
            shortName
            shield
          }
        }
      }
    }
  }
`;
